import { axios } from "../../lib/axios";

export type PatchResourcePayload = {
  isDemo?: boolean;
  title?: string;
  url?: string;
};

export const PatchResource = (id: string, payload: PatchResourcePayload) => {
  return axios.patch(`/resource/${id}`, payload).then((res) => res.data);
};
